import type { IAPI } from '../../apiResponse';
import type { IRequestOptions } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ICollection } from '../collection-schema';

export async function listPublicCollectionsV1Api(options?: IRequestOptions) {
  return getRequest<IAPI<ICollection[]>>({
    path: '/collections/list/v1',
    options,
  });
}
